<template>
    <MainPage />
</template>

<script setup>
import {
    onBeforeMount,
    onMounted,
    onUpdated,
    onUnmounted
} from "vue";
import { faLog } from "../common/faCommon.js";
import MainPage from "../components/MainPage.vue";

/**
 * VUE.js Methods...
 */
onBeforeMount(() => {
    faLog(0, "[MainPageView] [onBeforeMount]");
});

onMounted(() => {
    faLog(0, "[MainPageView] [onMounted]");
});

onUpdated(() => {
    faLog(0, "[MainPageView] [onUpdated]");
});

onUnmounted(() => {
    faLog(0, "[MainPageView] [onUnmounted]");
});
</script>
